import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Clock',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("circle", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", cx: "16", cy: "16", r: "13" }
      }), h("polyline", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", points: "16,7 16,16 21.33,18.67" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "3", y1: "16", x2: "6", y2: "16" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "6.81", y1: "25.19", x2: "8.93", y2: "23.07" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "16", y1: "29", x2: "16", y2: "26" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "25.19", y1: "25.19", x2: "23.07", y2: "23.07" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "29", y1: "16", x2: "26", y2: "16" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "25.19", y1: "6.81", x2: "23.07", y2: "8.93" }
      }), h("line", {
        attrs: { fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", x1: "6.81", y1: "6.81", x2: "8.93", y2: "8.93" }
      })]
    );
  }
};